module.exports = __webpack_public_path__ + "img/signer.db028a1a.svg";